// src/components/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname,search  } = useLocation();

    useEffect(() => {
        console.log("pathname===",pathname,search)
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [pathname,search]);

    return null;
};

export default ScrollToTop;
